import { r as registerInstance, c as createEvent, h, g as getElement } from './index-d4808923.js';
import { R as ResizeObserver } from './ResizeObserver-24585425.js';
import { b as bem } from './index.esm-7182addc.js';
import { g as getTimeZoneCity, a as getReadableTimeZoneOffset } from './date-utils-73271ab4.js';
import { g as getTextColor } from './getTextColor-1c68221e.js';

const gravityDateInputCss = ".gravity-date-input {\n  display: flex;\n  flex-direction: column;\n}\n.gravity-date-input__input-wrapper {\n  container-name: date-input;\n  container-type: inline-size;\n  position: relative;\n  width: 100%;\n}\n.gravity-date-input__input {\n  align-items: center;\n  background-color: #FFFFFF;\n  border-bottom: var(--gravity-date-input-border-bottom, 1px solid rgba(0, 15, 30, 0.2));\n  border-left: var(--gravity-date-input-border-left, 1px solid rgba(0, 15, 30, 0.2));\n  border-radius: var(--gravity-date-input-border-radius, 6px);\n  border-right: var(--gravity-date-input-border-right, 1px solid rgba(0, 15, 30, 0.2));\n  border-top: var(--gravity-date-input-border-top, 1px solid rgba(0, 15, 30, 0.2));\n  box-sizing: border-box;\n  cursor: pointer;\n  display: flex;\n  outline: none;\n  white-space: nowrap;\n}\n.gravity-date-input__input:hover {\n  border-color: rgba(0, 15, 30, 0.45);\n}\n.gravity-date-input__input:focus-visible {\n  outline: #1B6AEE solid 2px;\n  outline-offset: 2px;\n}\n.gravity-date-input--active .gravity-date-input__input {\n  border-color: rgba(0, 15, 30, 0.2);\n}\n.gravity-date-input--invalid .gravity-date-input__input, .gravity-date-input--required .gravity-date-input__input {\n  border-color: #DB0A40;\n}\n.gravity-date-input--readonly .gravity-date-input__input, .gravity-date-input--readonly .gravity-date-input__input:hover {\n  background-color: rgba(0, 15, 30, 0.05);\n  border-color: transparent;\n  cursor: text;\n}\n.gravity-date-input--readonly .gravity-date-input__input:focus {\n  outline: #1B6AEE solid 2px;\n  outline-offset: 2px;\n}\n.gravity-date-input--disabled .gravity-date-input__input, .gravity-date-input--disabled .gravity-date-input__input:hover {\n  background-color: rgba(0, 15, 30, 0.05);\n  border-color: transparent;\n  cursor: default;\n}\n.gravity-date-input--disabled .gravity-date-input__input {\n  color: rgba(0, 15, 30, 0.45);\n}\n.gravity-date-input--highlighted .gravity-date-input__input {\n  background-color: #F4F8FE;\n}\n.gravity-date-input--highlighted .gravity-date-input__input:hover {\n  background-color: #F4F8FE;\n}\n.gravity-date-input__input-value {\n  align-items: center;\n  display: flex;\n  flex: 1;\n  gap: 4px;\n  overflow: hidden;\n}\n.gravity-date-input__input-value__date-range-wrapper {\n  align-items: center;\n  display: flex;\n  gap: 8px;\n}\n.gravity-date-input__input-value__date-range-wrapper__first {\n  align-items: center;\n  display: flex;\n  gap: 8px;\n}\n.gravity-date-input__input-value__date {\n  align-items: center;\n  display: flex;\n  gap: 8px;\n}\n.gravity-date-input__input-value__timezone-city {\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n.gravity-date-input__input-icon {\n  margin-inline-start: 6px;\n}\n.gravity-date-input__icon-group {\n  align-items: center;\n  display: flex;\n  gap: 6px;\n}\n.gravity-date-input__clear-button {\n  align-items: center;\n  background: none;\n  background-color: rgba(0, 15, 30, 0.1);\n  border: 0;\n  border-radius: 9999px;\n  cursor: pointer;\n  display: flex;\n  justify-content: center;\n  margin-left: 6px;\n  padding: 0;\n}\n.gravity-date-input__clear-button--hidden {\n  visibility: hidden;\n}\n.gravity-date-input__clear-button:hover {\n  background-color: rgba(0, 15, 30, 0.2);\n}\n.gravity-date-input--size-medium .gravity-date-input__input {\n  height: 40px;\n  padding: 8px 12px;\n}\n.gravity-date-input--size-small .gravity-date-input__input {\n  border-radius: var(--gravity-date-input-border-radius, 4px);\n  height: 32px;\n  padding: 6px 8px;\n}\n.gravity-date-input--size-small .gravity-date-input__input-icon {\n  margin-inline-start: 4px;\n}\n.gravity-date-input--size-small .gravity-date-input__input-value__date-range-wrapper, .gravity-date-input--size-small .gravity-date-input__input-value__date-range-wrapper__first {\n  gap: 4px;\n}\n.gravity-date-input--size-small .gravity-date-input__input-value__date {\n  gap: 4px;\n}\n.gravity-date-input--size-small .gravity-date-input__icon-group {\n  gap: 4px;\n}\n.gravity-date-input--size-small .gravity-date-input__clear-button {\n  margin-inline-start: 4px;\n}\n@container (max-width: 350px) {\n  :host([type=datetime]) .gravity-date-input__input-value__date, :host([type=daterange]) .gravity-date-input__input-value__date, :host([type=daterange]) .gravity-date-input__input-value__date-range-wrapper {\n    align-items: unset;\n    flex-direction: column;\n    gap: unset;\n  }\n}\n@container (max-width: 500px) {\n  :host([type=datetimerange]) .gravity-date-input__input-value__date {\n    align-items: unset;\n    flex-direction: column;\n    gap: unset;\n  }\n  :host([type=datetimerange]) .gravity-date-input.gravity-date-input--size-small .gravity-date-input__input-value__date {\n    /* stylelint-disable selector-max-compound-selectors */\n    /* stylelint-enable selector-max-compound-selectors */\n  }\n  :host([type=datetimerange]) .gravity-date-input.gravity-date-input--size-small .gravity-date-input__input-value__date :first-child {\n    margin-bottom: -2px;\n  }\n  :host([type=datetimerange]) .gravity-date-input.gravity-date-input--size-small .gravity-date-input__input-value__date :last-child {\n    margin-top: -2px;\n  }\n}";
const GravityDateInputStyle0 = gravityDateInputCss;

const generateClassNames = bem('gravity-date-input');
const GravityDateInput = class {
    constructor(hostRef) {
        registerInstance(this, hostRef);
        this.selected = createEvent(this, "selected", 5);
        this.timezoneChanged = createEvent(this, "timezoneChanged", 5);
        this.resizeObserver = new ResizeObserver((entries) => {
            entries.forEach(() => {
                const width = this.input.getBoundingClientRect().width;
                if ((this.type == 'datetime' || this.type == 'daterange') && width <= 350) {
                    this.dateTextSize = 'xx-small';
                }
                else if (this.type == 'datetimerange' && width <= 500) {
                    this.dateTextSize = 'xx-small';
                }
                else {
                    this.dateTextSize = this.size === 'small' ? 'x-small' : 'small';
                }
            });
        });
        this.deriveTimezoneFromValue = true;
        this.disabled = false;
        this.highlighted = false;
        this.infoBottom = false;
        this.infoPosition = 'top';
        this.infoText = '';
        this.infoWidth = undefined;
        this.inline = false;
        this.inlineLabelWidth = '33%';
        this.invalid = false;
        this.label = undefined;
        this.maxDate = undefined;
        this.minDate = undefined;
        this.placeholder = undefined;
        this.positionStrategy = 'absolute';
        this.readonly = false;
        this.required = false;
        this.size = 'medium';
        this.timezone = undefined;
        this.timezoneSelect = true;
        this.type = 'date';
        this.validationMessage = '';
        this.value = undefined;
        this.dateTextSize = 'xx-small';
        this.inputIsActive = false;
        this.secondSelectedDate = undefined;
        this.selectedDate = undefined;
        this.showClearButton = false;
        this.valueMissing = false;
    }
    valueHandler(newValue, oldValue) {
        if (newValue) {
            this.setSelectedValue(newValue);
            this.validate();
        }
        else if (oldValue !== undefined) {
            this.clearSelection();
        }
    }
    requiredChangeHandler() {
        if (!this.required && this.valueMissing) {
            this.valueMissing = false;
        }
    }
    onClick(event) {
        if (!this.inputIsActive) {
            return;
        }
        if (event.target !== this.element) {
            this.inputIsActive = false;
            this.showClearButton = false;
            this.validate();
        }
    }
    validate() {
        if (!this.required) {
            return;
        }
        if (((this.type == 'time' || this.type == 'date' || this.type == 'datetime') && !this.selectedDate) ||
            ((this.type === 'daterange' || this.type === 'datetimerange') && (!this.selectedDate || !this.secondSelectedDate))) {
            this.valueMissing = true;
        }
        else if (this.valueMissing) {
            this.valueMissing = false;
        }
    }
    setSelectedValue(value) {
        if (this.value.split('/').length > 1) {
            this.selectedDate = new Date(value.split('/')[0]);
            this.secondSelectedDate = new Date(value.split('/')[1]);
        }
        else {
            this.selectedDate = new Date(value);
        }
    }
    renderInputWrapper() {
        const offsetMap = {
            small: 8,
            medium: 6,
        };
        return [
            h("div", { class: generateClassNames('input-wrapper') }, h("div", { id: "input", class: generateClassNames('input'), tabIndex: this.disabled ? -1 : 0, ref: (el) => (this.input = el), onClick: () => this.handleInputClick() }, h("span", { class: generateClassNames('input-value') }, this.renderInputContent(), this.renderTimezone()), h("div", { class: generateClassNames('icon-group') }, this.renderClearButton()), this.renderInputIcon())),
            h("gravity-datepicker", { class: generateClassNames('datepicker'), deriveTimezoneFromValue: this.deriveTimezoneFromValue, disabled: this.disabled || this.readonly, for: "input", "max-date": this.maxDate, "min-date": this.minDate, offset: offsetMap[this.size], onIsOpen: (event) => this.handleIsOpen(event), onSelected: (event) => this.handleSelected(event), onTimezoneChanged: (event) => this.handleTimezoneChanged(event), position: "left", positionStrategy: this.positionStrategy, ref: (el) => (this.datepicker = el), timezone: this.timezone, timezoneSelect: this.timezoneSelect, type: this.type, value: this.value }),
        ];
    }
    renderClearButton() {
        return (h("button", { class: generateClassNames('clear-button', {
                hidden: !this.showClearButton || this.readonly,
            }), tabindex: -1, onClick: ($event) => {
                this.handleClear($event);
            } }, h("gravity-icon", { class: generateClassNames('clear-button__icon'), name: "close", color: "dark", size: "xxx-small" })));
    }
    renderInputIcon() {
        if (this.readonly) {
            return;
        }
        return (h("gravity-icon", { class: generateClassNames('input-icon'), color: this.disabled ? 'dark-muted' : 'dark-subtle', name: this.type == 'time' ? 'watch' : 'calendar', size: this.size === 'small' ? 'xxx-small' : 'xx-small' }));
    }
    renderTimezone() {
        if (this.type === 'time' || !this.selectedDate || !this.timezone || !this.timezoneSelect) {
            return;
        }
        return [
            h("gravity-text", { class: generateClassNames('input-value__timezone-city'), color: getTextColor(this.disabled, this.highlighted), size: "xx-small" }, getTimeZoneCity(this.timezone)),
            h("gravity-text", { class: generateClassNames('input-value__timezone-offset'), color: getTextColor(this.disabled, this.highlighted), size: "xx-small" }, getReadableTimeZoneOffset(this.timezone, this.selectedDate)),
        ];
    }
    handleClear(event) {
        event.stopPropagation();
        this.clearSelection();
        this.inputIsActive = false;
        this.selected.emit(this.value);
    }
    clearSelection() {
        this.selectedDate = undefined;
        this.secondSelectedDate = undefined;
        this.value = '';
        this.showClearButton = false;
        this.validate();
    }
    renderInputContent() {
        if (!this.selectedDate && !this.secondSelectedDate && this.placeholder) {
            return (h("gravity-text", { color: "dark-muted", size: this.size === 'small' ? 'x-small' : 'small' }, this.placeholder));
        }
        switch (this.type) {
            case 'time':
                return this.renderTimeInputContent();
            case 'date':
                return this.renderDateTime(this.selectedDate, false);
            case 'datetime':
                return this.renderDateTime(this.selectedDate, true);
            case 'daterange':
                return this.renderDateRangeContent(false);
            case 'datetimerange':
                return this.renderDateRangeContent(true);
        }
    }
    dateToAMPMTimeStringLowercase(date) {
        const dateString = date.toLocaleDateString('en-US', {
            hour: '2-digit',
            minute: '2-digit',
            hour12: true,
            timeZone: this.type == 'time' ? undefined : this.timezone,
        });
        return dateString.split(', ')[1].replace(' ', '');
    }
    dateToLocaleISOStringHumanReadable(date) {
        const dateString = date.toLocaleDateString('en-ZA', {
            hour: '2-digit',
            minute: '2-digit',
            hour12: true,
            timeZone: this.timezone,
        });
        return dateString.split(', ')[0].replace(/\//g, '-');
    }
    renderTimeInputContent() {
        return (this.selectedDate && (h("gravity-text", { color: getTextColor(this.disabled, this.highlighted), size: this.size === 'small' ? 'x-small' : 'small' }, this.dateToAMPMTimeStringLowercase(this.selectedDate))));
    }
    renderDateTime(date, renderTime = false) {
        return (date && (h("div", { class: generateClassNames('input-value__date') }, h("gravity-text", { color: getTextColor(this.disabled, this.highlighted), weight: this.dateTextSize == 'xx-small' ? 'medium' : 'regular', size: this.dateTextSize }, this.dateToLocaleISOStringHumanReadable(date)), renderTime && (h("gravity-text", { color: getTextColor(this.disabled, this.highlighted), size: this.dateTextSize }, this.dateToAMPMTimeStringLowercase(date))))));
    }
    renderDateRangeContent(renderTime = false) {
        return (h("div", { class: generateClassNames('input-value__date-range-wrapper') }, h("div", { class: generateClassNames('input-value__date-range-wrapper__first') }, this.renderDateTime(this.selectedDate, renderTime), this.secondSelectedDate && (h("gravity-text", { size: "xx-small", color: "dark-subtle" }, "\u2013"))), this.renderDateTime(this.secondSelectedDate, renderTime)));
    }
    handleSelected(event) {
        this.value = event.detail;
        this.selected.emit(this.value);
        this.showClearButton = !!event.detail;
    }
    handleTimezoneChanged(event) {
        this.timezone = event.detail;
        this.timezoneChanged.emit(event.detail);
    }
    handleIsOpen(event) {
        const isOpen = event.detail;
        if (!isOpen) {
            this.input.focus();
            this.validate();
        }
    }
    handleInputClick() {
        if (this.disabled || this.readonly) {
            return;
        }
        this.inputIsActive = !this.inputIsActive;
    }
    getDefaultPlaceholder() {
        switch (this.type) {
            case 'time':
                return 'Select a time';
            case 'date':
            case 'datetime':
                return 'Select a date';
            case 'daterange':
            case 'datetimerange':
                return 'Select a date range';
        }
    }
    componentWillLoad() {
        if (this.value) {
            this.setSelectedValue(this.value);
        }
        if (!this.placeholder) {
            this.placeholder = this.getDefaultPlaceholder();
        }
    }
    componentDidLoad() {
        this.input.onmouseenter = () => {
            if (this.readonly || this.disabled) {
                return;
            }
            this.showClearButton = !!this.selectedDate;
        };
        this.input.onmouseleave = () => {
            if (!this.inputIsActive) {
                this.showClearButton = false;
            }
        };
        this.element.onkeydown = (event) => {
            if (event.key !== 'Enter') {
                return;
            }
            if (this.disabled || this.readonly) {
                return;
            }
            if (this.element.shadowRoot.activeElement != this.input) {
                return;
            }
            this.inputIsActive = true;
            this.datepicker.open = !this.datepicker.open;
        };
        this.element.onblur = () => {
            this.validate();
        };
        this.resizeObserver.observe(this.input);
    }
    disconnectedCallback() {
        this.valueMissing = false;
        this.resizeObserver.disconnect();
    }
    render() {
        return (h("gravity-form-field", { key: 'bdc2e09d91b0abc17837c45a990c705167888aff', label: this.label, required: this.required, disabled: this.disabled, highlighted: this.highlighted, infoBottom: this.infoBottom, infoText: this.infoText, infoPosition: this.infoPosition, infoWidth: this.infoWidth, inline: this.inline, inlineLabelWidth: this.inlineLabelWidth, size: this.size, invalid: !!this.validationMessage || this.valueMissing, validationMessage: this.valueMissing ? 'This field is required' : this.validationMessage }, h("div", { key: '4e1b791bde6ef3bb74598bad8ad350af3b291b26', class: generateClassNames({
                required: this.valueMissing,
                active: this.inputIsActive,
                readonly: this.readonly,
                disabled: this.disabled,
                inline: this.inline,
                invalid: this.invalid || !!this.validationMessage,
                size: this.size,
                highlighted: this.highlighted,
            }) }, this.renderInputWrapper())));
    }
    get element() { return getElement(this); }
    static get watchers() { return {
        "value": ["valueHandler"],
        "required": ["requiredChangeHandler"]
    }; }
};
GravityDateInput.style = GravityDateInputStyle0;

export { GravityDateInput as gravity_date_input };

//# sourceMappingURL=gravity-date-input.entry.js.map